// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/announcement_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/announcement_model.proto.
 */
export const file_bffuser_v1_announcement_model: GenFile = /*@__PURE__*/
  fileDesc("CiNiZmZ1c2VyL3YxL2Fubm91bmNlbWVudF9tb2RlbC5wcm90bxIKYmZmdXNlci52MSJvChNBbm5vdW5jZW1lbnRTdW1tYXJ5EhcKD2Fubm91bmNlbWVudF9pZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIwCgxwdWJsaXNoZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIn8KDEFubm91bmNlbWVudBIXCg9hbm5vdW5jZW1lbnRfaWQYASABKAkSDQoFdGl0bGUYAiABKAkSMAoMcHVibGlzaGVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIVCg1ib2R5X21hcmtkb3duGAQgASgJQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * AnnouncementSummary は一覧 1 行分のリリース告知 (お知らせ)。本文は持たない
 * (本文は GetAnnouncement)。告知は全組織共通の読み取り専用データで
 * organization_id を持たない。
 *
 * @generated from message bffuser.v1.AnnouncementSummary
 */
export type AnnouncementSummary = Message<"bffuser.v1.AnnouncementSummary"> & {
  /**
   * 告知 ID。配信側が原稿ファイル名 (YYYY-MM-DD / YYYY-MM-DD-N) から付ける。
   *
   * @generated from field: string announcement_id = 1;
   */
  announcementId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * 初回配信時に付与される公開時刻。本文訂正では変わらない。後続の未読判定は
   * この値を比較キーにする (map #8571)。
   *
   * @generated from field: google.protobuf.Timestamp published_at = 3;
   */
  publishedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.AnnouncementSummary.
 * Use `create(AnnouncementSummarySchema)` to create a new message.
 */
export const AnnouncementSummarySchema: GenMessage<AnnouncementSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_announcement_model, 0);

/**
 * Announcement は詳細 1 件分のリリース告知。body_markdown は原稿 markdown を
 * そのまま運び、描画 (見出し階層・生 HTML の非描画) は frontend の責務。
 *
 * @generated from message bffuser.v1.Announcement
 */
export type Announcement = Message<"bffuser.v1.Announcement"> & {
  /**
   * @generated from field: string announcement_id = 1;
   */
  announcementId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 3;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: string body_markdown = 4;
   */
  bodyMarkdown: string;
};

/**
 * Describes the message bffuser.v1.Announcement.
 * Use `create(AnnouncementSchema)` to create a new message.
 */
export const AnnouncementSchema: GenMessage<Announcement> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_announcement_model, 1);

